import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { TextRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: TextRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function TextRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "text",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("TextRegionTypeCard.title")}
      description={t("TextRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
